module.exports = __webpack_public_path__ + "static/img/21层.9f103f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/21层.png
// module id = K/8i
// module chunks = 0